"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function AnnouncementSwiper({ announcements = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused && announcements.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % announcements.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isPaused, announcements.length]);

  if (!announcements || announcements.length === 0) {
    return null; // Don't render anything if there are no announcements
  }

  return (
    <div
      className="fixed left-0 right-0 top-0 z-40 overflow-hidden bg-primary py-4 text-primary-foreground"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="text-center text-lg font-medium"
        >
          {announcements[currentIndex]?.title || "No announcement available"}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
